import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DsBanner from '../../atoms/banner';
import DsCoinBadge from '../CoinBadge';
import DsLabelError from '../../atoms/label/labelError';

const classStatus = (status) => {
  switch (status) {
    case 'CANC':
    case 'REV':
      return 'bg-status-red border border-status-red bg-opacity-25';
    default:
      return 'bg-gray-200';
  }
};

const isCancelled = ((status) => status === 'CANC' || status === 'REV')();

const BannerStatus = (props: {
  children: any, className: any, booking: any, lang: any, loyalty: any, loggedUser: any
}, context: { t: () => {} }) => {
  const coins = props.booking.loyalty.checkout_coins || 0;
  const status = props.booking.status || null;
  return (
          <DsBanner className={`${props.className || ''} ${classStatus(status)}`}>
            {isCancelled && (<DsLabelError
                    className={`${props.className || ''}`}>{context.t('This booking is already cancelled')}</DsLabelError>)}
            <div className="flex flex-wrap lg:flex-nowrap">
              <div className="flex-grow-default">{props.children}</div>
              <DsCoinBadge coins={coins} lang={props.lang} loyalty={props.loyalty} loggedUser={props.loggedUser}
                           showURL={true} className="p-2">
                {context.t('When checking out of the hotel, {chain} coins will be added to the account of the {chain} Member who made the reservation. The amount will be based on the percentage corresponding to their membership level, calculated on the amount of the stay (without tax).',
                  { chain: props.chainData.loyalty_name.toUpperCase() })}
              </DsCoinBadge>
            </div>
          </DsBanner>
  );
};

BannerStatus.propTypes = {
  booking: PropTypes.object.isRequired,
};

BannerStatus.contextTypes = {
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  chainData: state.session.chainData,
});

export default connect(mapStateToProps)(BannerStatus);
